if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute("data-media-id");
      const zoomSlider = this.querySelector('media-zoom-slider');

      if (zoomSlider) {
        zoomSlider.goToMediaId(mediaId);
      } else {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }
      }

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
